import React, { useContext } from "react";
import useApiEp from "../../hooks/useApiEp";
import { UserContext } from "../../context/UserProvider";

const RdCampaignCheck = ({ id }) => {
  const { user } = useContext(UserContext);
  const { data } = useApiEp(
    `/campaign/get-campaign-detail/${id}`,
    user?.userType === "SuperAdmin"
  );
  return <div></div>;
};

export default RdCampaignCheck;
